export default "__VITE_ASSET__3d978057__"